export default __webpack_public_path__ + "static/media/paycor_logo_fullcolor.26cc008d.svg";